export enum RetailerKey {
  AmazonUS = 'amazon_us',
  AmazonUK = 'amazon_uk',
  WalmartUS = 'walmart_us',
}

export interface RetailerConfig {
  key: RetailerKey;
  displayName: string;
  itemIdLabel: string;
  // Full validation regex
  itemIdPattern: RegExp;
  // Prefix regex for real-time detection while typing (not anchored at end).
  // Must be mutually exclusive across retailers so detection is unambiguous.
  detectionPattern: RegExp;
  // Used in inputs, filter dropdowns, table cells and before the category on the PDP header.
  baseIcon: string;
  buttonIconName: string;
  buildLiveUrl: (productId: string) => string;
}

// Shared base for all Amazon marketplace entries — only domain and display name differ per region.
const AMAZON_BASE = {
  itemIdLabel: 'ASIN',
  itemIdPattern: /^B[A-Z0-9]{9}$/i,
  detectionPattern: /^B[A-Z0-9]+$/i,
  baseIcon: 'AmazonIcon',
  buttonIconName: 'AmazonCircleIcon',
} satisfies Partial<RetailerConfig>;

export const RETAILER_CONFIG_MAP: Record<RetailerKey, RetailerConfig> = {
  [RetailerKey.AmazonUS]: {
    ...AMAZON_BASE,
    key: RetailerKey.AmazonUS,
    displayName: 'Amazon US',
    buildLiveUrl: (asin) => `https://www.amazon.com/dp/${asin}`,
  },
  [RetailerKey.AmazonUK]: {
    ...AMAZON_BASE,
    key: RetailerKey.AmazonUK,
    displayName: 'Amazon UK',
    buildLiveUrl: (asin) => `https://www.amazon.co.uk/dp/${asin}`,
  },
  [RetailerKey.WalmartUS]: {
    key: RetailerKey.WalmartUS,
    displayName: 'Walmart US',
    itemIdLabel: 'Product Id',
    itemIdPattern: /^\d{5,13}$/,
    detectionPattern: /^\d+$/,
    baseIcon: 'WalmartCircleIcon',
    buttonIconName: 'WalmartCircleIcon',
    buildLiveUrl: (productId) => `https://www.walmart.com/ip/${productId}`,
  },
} as const;

export const DEFAULT_RETAILER_REGION_ID = RetailerKey.AmazonUS;
